import { useDispatch, useSelector } from 'react-redux'
import { AVAILABLE_COMMUNICATION_BOARD_SECTIONS } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/constants'
import { isContentEmpty } from '@/shared/tools/htmlHelper'
import { selectCommunicationBoardState } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { useEffect } from 'react'
import { communicationBoardModuleActions } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/CommunicationBoardSagas'

const useCommunicationBoardData = () => {
  const { sections } = useSelector(selectCommunicationBoardState)
  const dispatch = useDispatch()
  const visibleSections = AVAILABLE_COMMUNICATION_BOARD_SECTIONS.filter(sectionKey => {
    const sectionData = sections.find(s => s.section === sectionKey)
    return sectionData && !isContentEmpty(sectionData.content)
  })

  useEffect(() => {
    dispatch({
      type: communicationBoardModuleActions.COMMUNICATION_BOARD_MODULE_LOAD_DATA,
    })
  }, [])

  return { visibleSections }
}

export default useCommunicationBoardData
